"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="finalcalltoaction" className="bg-background py-24 md:py-32 px-6 border-t border-border overflow-hidden">
      <div ref={ref} className={`mx-auto max-w-6xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-8">
            <span className="font-mono text-sm font-semibold tracking-widest text-primary uppercase mb-6 block">
              Chronos Index
            </span>
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight tracking-tight">
              Vuoi diventare il prossimo caso studio?
            </h2>
            <p className="mt-6 text-xl text-muted-foreground max-w-2xl">
              Raccontami il tuo progetto. Costruiamo qualcosa che vale la pena mostrare.
            </p>
          </div>
          
          <div className="lg:col-span-4 flex lg:justify-end">
            <Button size="lg" className="group rounded-lg text-lg px-8 h-14 w-full sm:w-auto shadow-lg hover:shadow-xl transition-all">
              Parliamoci
              <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}